package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun HeatMetalMetadata() {
    SpellMetadata(
        spellIndex = "heat-metal",
        castingTime = "1 action",
        range = "60 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A piece of iron and a flame.",
        duration = "Up to 1 minute",
        damageBase = "Fire 2d8",
        damageScaling = mapOf("2" to "2d8", "3" to "3d8", "4" to "4d8", "5" to "5d8", "6" to "6d8", "7" to "7d8", "8" to "8d8", "9" to "9d8"),
        savingThrow = "CON (Other)",
        aoe = null,
        concentration = true
    )
}
